<template>
  <div v-if="isShoppingEnabled()" class="container">
    <CourseListHorizontal>
      <template #header>
        {{ $t("common.popular_courses") }}
      </template>
      <template #body>
        <swiper
          :loop="false"
          :breakpoints="swiperFeaturedCoursesOptions.breakpoints"
          :slides-per-view="4"
          :space-between="50"
          @slide-change="onSlideChange"
        >
          <Loading v-if="productsStore.loading" />
          <swiper-slide v-for="course in productsStore.list" :key="course.id">
            <CoursePopular :course="course" height="100%" />
          </swiper-slide>
        </swiper>
      </template>
    </CourseListHorizontal>
  </div>
</template>
<script>
import CourseListHorizontal from "@/components/course/CourseListHorizontal.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import CoursePopular from "@/components/course/Course.vue";
import Loading from "@/components/Loading.vue";
import { useProductsStore } from "@/store/modules/products.store";
import { isShoppingEnabled } from "@/util/helpers";

export default {
  components: {
    CourseListHorizontal,
    Swiper,
    SwiperSlide,
    CoursePopular,
    Loading,
  },
  setup() {
    const productsStore = useProductsStore();

    const onSlideChange = () => {};

    return {
      onSlideChange,
      productsStore,
    };
  },
  data() {
    return {
      swiperFeaturedCoursesOptions: {
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 40,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  created() {
    this.productsStore.request(1, 5, "bestsellers");
  },
  methods: { isShoppingEnabled },
};
</script>

<style lang="scss">
.container {
  .swiper-slide {
    display: flex;
    height: unset;
  }

  .swiper-wrapper {
    height: 500px;
  }
}
</style>
